import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxColorBox = _resolveComponent("DxColorBox");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, { name: _ctx.formFieldName }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxColorBox, {
                id: identification,
                name: identification,
                disabled: disabled,
                value: _ctx.modelValue,
                placeholder: _ctx.placeholder,
                "value-change-event": "keyup",
                onValueChanged: _ctx.onChange
            }, null, 8, ["id", "name", "disabled", "value", "placeholder", "onValueChanged"])
        ]),
        _: 1
    }, 16, ["name"]));
}
